import { useState, useEffect } from 'react';
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit';
import WlmListCompo from '../../Pages/WLM/wlmList';
import { FoundationsConstants } from '../../FoundationsConstants';
import LeaveManagementForm from '../LeaveManager/LeaveApplicationForm';
import WlmForm from '../../Pages/WLM/wlmForm';
import { wlmStates } from '../../Redux/WLM/wlmEnums';
import StatCaseForm from '../StatCase/StatCaseForm';
import { StatPortalIdProvider } from '../StatCase/StatCaseFormHooks/StatPortalIdContext'
import { getRunVUDataObject } from '../../VisualunitHelpers';

interface ActivePanelProps {
  report: VisualUnitApiDTO_VisualUnit;
}

const ActivePanel: React.FC<ActivePanelProps> = ({ report}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activeComponent, setActiveComponent] = useState<string | null>(null); // Store the key to decide which component to render
  const [status, setStatus] = useState<string | null>(null); // Store the status for conditional rendering
  const runVUData = {
    id : report?.VisualUnitId,
    appGuid : report.AppGUID
}

  const handleAction = () => {
    let vuObj;
    // Handle when AppGUID is null
    // if (report.AppGUID == null) {
        // const userVisualUnitsInfo = (window as any).healthLevelWorkspaceVU.userVisualUnitsInfo;
    //     userVisualUnitsInfo.forEach((obj: any) => {
    //     if (obj.basevu.VisualUnitId === report.VisualUnitId) {
    //       vuObj = obj;
    //       report.AppGUID = obj.basevu.AppGUID;
    //     }
    //   });
    // }
        switch (report.AppGUID) {
          case FoundationsConstants.worklist_guid.lms_form:
            setActiveComponent('lms_form')
            break;

          case FoundationsConstants.worklist_guid.workloadrequest_form:
            setActiveComponent('workloadrequest_form')
            break; 

          case FoundationsConstants.worklist_guid.workloadrequest_openlist:
            setStatus(wlmStates.Open.toString());
            setActiveComponent('workloadrequest_list')
            break;

          case FoundationsConstants.worklist_guid.workloadrequest_pendinglist:
            setStatus(wlmStates.Pending.toString());
            setActiveComponent('workloadrequest_list');
            break;

          case FoundationsConstants.worklist_guid.workloadrequest_approvedlist:
            setStatus(wlmStates.Approved.toString());
            setActiveComponent('workloadrequest_list');
            break;

          case FoundationsConstants.worklist_guid.workloadrequest_declinedlist:
            setStatus(wlmStates.Declined.toString());
            setActiveComponent('workloadrequest_list');
            break;
          case FoundationsConstants.worklist_guid.caseform:
            setActiveComponent('caseform');
            break;

          default:
            setActiveComponent(null);
        }
    }
  
  // Effect hook to run handleAction when the report changes
  useEffect(() => {
    if (report) {
      handleAction();
    }
  }, [report]);

  return (
    <div>
      {isLoading && <div>Loading...</div>}
      <div>
        {activeComponent === 'lms_form' && <LeaveManagementForm />}
        {activeComponent === 'workloadrequest_form' && <WlmForm />}
        {activeComponent === 'caseform' && <StatCaseForm runVUData={runVUData} reasonForCall={'SHOW'} />}
        {activeComponent === 'workloadrequest_list' && status && (
          <WlmListCompo status={status} />
        )}
        {!activeComponent && <div>This guid could not be found.</div>}
      </div>
    </div>
  );
};
export default ActivePanel;
